import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
    selector: 'app-status-filter',
    templateUrl: './status-filter.component.html',
    styleUrls: ['./status-filter.component.scss'],
    standalone: false
})
export class StatusFilterComponent implements OnInit, OnDestroy {
  @Input() statusOptions = [
    {
      label: 'Awaiting Submission',
      value: 'draft',
      isChecked: false,
    },
    {
      label: 'Awaiting Approval',
      value: 'submitted',
      isChecked: false,
    },
    {
      label: 'Approved',
      value: 'approved',
      isChecked: false,
    },
    {
      label: 'Rejected',
      value: 'rejected',
      isChecked: false,
    },
  ];

  isStatusAllChecked = false;
  buttonLabel = 'Status: All';
  isOpen = false;
  statusList = [];
  searchForm = new FormGroup({
    statusSearch: new FormControl(''),
  });

  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.route.queryParams
      .pipe(takeUntil(this.onDestroy))
      .subscribe(qp => {
        if (qp.status) {
          if (Array.isArray(qp.status)) {
            this.statusList = qp.status;
          } else {
            this.statusList = [qp.status];
          }

          this.statusOptions.forEach(o => {
            o.isChecked = this.statusList.includes(o.value);
          });

          this.isStatusAllChecked = this.statusList.length === this.statusOptions.length;
        } else {
          this.statusList = [];
        }

        this.generateLabel();
      });
  }

  onStatusCheckboxChange(event) {
    this.router.navigate([], {
      queryParams: {
        status: event,
      },
      queryParamsHandling: 'merge',
    });
  }

  generateLabel() {
    const statusCount = this.statusList?.length ?? 0;
    const totalStatuses = this.statusOptions.length;

    if (statusCount === totalStatuses) {
      this.buttonLabel = 'Status: All';
    } else {
      this.buttonLabel = `Status (${statusCount})`;
    }
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
